import Api from '../../api';

export function getService(serviceHash, setService, setValidPassword, password: string | null = '') {
  if (password === '') {
    password = localStorage.getItem(`${serviceHash}-password`);
  }

  const preview = new URLSearchParams(window.location.search).get('preview');

  return Api.service(serviceHash, password ?? '', preview ?? false).then((service) => {
    if (service.error) {
      window.location.href = service.redirect;
    }

    setService(service);
    if (password !== '') {
      setValidPassword(service.unlocked);
    }

    if (service.unlocked && password) {
      localStorage.setItem(`${serviceHash}-password`, password);
    }
  });
}
